import Icon from '../components/Icon.vue'

Icon.register({
  video: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M336.2 64c26.4 0 47.8 21.4 47.8 47.8v288.4c0 26.4-21.4 47.8-47.8 47.8h-288.4c-26.4 0-47.8-21.4-47.8-47.8v-288.4c0-26.4 21.4-47.8 47.8-47.8h288.4zM525.6 101.7c21.3-14.6 50.4 0.4 50.4 25.8v256.9c0 25.5-29.2 40.4-50.4 25.8l-109.6-75.5v-157.4z'
      }
    ]
  }
})
